import { render, staticRenderFns } from "./ManualSearchBox.vue?vue&type=template&id=23b085d4&scoped=true"
import script from "./ManualSearchBox.vue?vue&type=script&lang=js"
export * from "./ManualSearchBox.vue?vue&type=script&lang=js"
import style0 from "./ManualSearchBox.vue?vue&type=style&index=0&id=23b085d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b085d4",
  null
  
)

export default component.exports